import { forwardRef } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";

import {
  SELECT_SCROLL_UP_ICON,
  type TSelectScrollUpButtonElement,
  type TSelectScrollUpButtonProps,
} from "@/ui/components/form/Select/Select.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { cn } from "@/ui/lib/utils";

export const SelectScrollUpButton = forwardRef<TSelectScrollUpButtonElement, TSelectScrollUpButtonProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <SelectPrimitive.ScrollUpButton
      data-component="SelectScrollUpButton"
      ref={ref}
      className={cn("flex cursor-default items-center justify-center py-1", className)}
      {...props}
    >
      <Icon icon={SELECT_SCROLL_UP_ICON} aria-hidden="true" size="sm" />
    </SelectPrimitive.ScrollUpButton>
  ),
);

SelectScrollUpButton.displayName = SelectPrimitive.ScrollUpButton.displayName;
